import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CodTransactionsList from "./components/CodTransactionsList";
import CodStatsCards from "src/_modules/MapitShip/views/CodInvoices/components/CodStatsCards";
import { WithdrawDialog } from "./components";
import { useGetCurrentInvoiceQuery } from "src/_api/mapitShipInvoice";
import { Helmet } from "react-helmet";
import { $APP_NAME } from "src/constants";

export default function CodInvoices() {
    const { t } = useTranslation()
    const { data: invoice } = useGetCurrentInvoiceQuery({});

    return (
        <>
            <Helmet>
                <title>COD Wallet | {$APP_NAME} </title>
            </Helmet>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 4 }}>
                <Typography variant="h4">{t("COD Wallet")}</Typography>
                <WithdrawDialog dueAmount={invoice?.dueAmount} />
            </Box>
            <CodStatsCards
                statsCard={["upcomingTotalAmount", "currentTotalAmount", "settledTotalAmount"]}
            />
            <Typography variant="h4" gutterBottom sx={{ mt: 4 }}>{t("COD Transactions")}</Typography>
            <CodTransactionsList />
        </>
    )
}